<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('all_packages')" icon="briefcase">
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('add', 'package', true)"
                          @click="openModal()"
                          v-if="$can('add_package')"
      />
    </app-page-top-section>


    <app-table
        id="package-table"
        :options="options"
        :card-view="false"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

    <package-create-edit-modal
        v-if="isLocationCreateOpenModalActive || isModalActive"
        v-model="isModalActive"
        :selected-url="selectedUrl"
        @close="isModalActive = false"
    />
<!--        :subPackage="subscriptionPackage"-->

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('package-table')"
        @cancelled="cancelled"
    />

  </div>
</template>

<script>
import PackageCreateEditModal from "./PackageCreateEditModal";
import PackageMixin from "../../Mixins/PackageMixin";
import {GET_ALL_PACKAGES} from "../../../Config/ApiUrl";
export default {
  components: {PackageCreateEditModal},
  mixins: [PackageMixin],
  data() {
    return {
      isModalActive: false,
      selectedUrl: '',
      isLocationCreateOpenModalActive: false,
      subscriptionPackage: [],
    }
  },
  methods: {
    openModal() {
      this.isModalActive = true;
      this.selectedUrl = ''
    },
    triggerActions(row, action, active) {
      this.subscriptionPackage = row;
      if (action.title === this.$t('edit')) {
        this.selectedUrl = `${GET_ALL_PACKAGES}/${row.id}`;
        this.isModalActive = true;
      }
      else {
        this.getAction(row, action, active)
      }
      // this.getAction(row, action, active)

    },
  }
}
</script>
